module.exports = __webpack_public_path__ + "img/fukuan.5f8154a6.png";